"use client"
import {ContainerDetailComponent} from "@/core/general/container/containerDetail.component";
import {FC, PropsWithChildren, Suspense, useEffect} from "react";
import {Provider} from "react-redux";
import {store} from "@/core/redux/store";
import {Loader} from "@/core/general/ui/loader.component";

interface containerProps {
    hasResponsivePadding?: boolean;
    onSettingClick?: any;
}

export const ContainerComponent: FC<PropsWithChildren<containerProps>> = (props) => {

    return (
            <Provider store={store}>
                <Suspense fallback={<Loader isFullScreen={false}/>}>
                    <ContainerDetailComponent hasResponsivePadding={props.hasResponsivePadding} onSettingClick={props.onSettingClick}>
                        {props.children}
                    </ContainerDetailComponent>
                </Suspense>
            </Provider>
    );
};
